'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './data.routes';

export class DataComponent {
  /*@ngInject*/
  constructor($http, $scope, $timeout, $location, lookup, theme, db, dbFactory) {
    this.$http = $http;
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.$location = $location;
    this.lookup = lookup;
    this.theme = theme;
    this.$scope.type = 'allSites';
    this.$scope.allSites = [];
    this.$scope.myListParcels = [];
    var listRecords = [];
    this.$scope.listCount = 0;
    this.$scope.bulkIds = [];
    this.$scope.numOfBulkParcels = 0;
    this.$scope.siteStatusFilterDisabled = false;
    this.$scope.filter = {};
    this.$scope.loading = true;
    this.$scope.hessTract = {};
    this.$scope.operators = {};
    this.$scope.filter = {
      jurisdiction: 'Alameda',
      in_cycle6: true,
      pa_county: 'Alameda'
    }
    

    this.db = db;
    this.dbFactory = dbFactory;

    this.$scope.affhPercent = ['zero_fifty_ami',
    'fifty_eighty_ami',
    'eighty_hundred_ami',
    'hundred_ami',
    'percent_people_of_color',
    'non_hispanic_black',
    'non_hispanic_white',
    'non_hispanic_api',
    'non_hispanic_other',
    'hispanic_latinx',
    'disability_status',
    'family_households',
    'non_family_households',
    'single_person_households',
    'households_with_children',
    'costburdened_housing',
    'overcrowded_housing',
    'substandard_housing']
    

    this.$scope.counties = [
      {
        FIPS: "CA001",
        County: "Alameda",
      },
      {
        FIPS: "CA013",
        County: "Contra Costa",
      },
      {
        FIPS: "CA041",
        County: "Marin",
      },
      {
        FIPS: "CA055",
        County: "Napa",
      },
      {
        FIPS: "CA075",
        County: "San Francisco",
      },
      {
        FIPS: "CA081",
        County: "San Mateo",
      },
      {
        FIPS: "CA085",
        County: "Santa Clara",
      },
      {
        FIPS: "CA095",
        County: "Solano",
      },
      {
        FIPS: "CA097",
        County: "Sonoma",
      },
    ];

    this.$scope.existing_use_lu = [
      {
        "existing_use_code": " Commercial, Educational/institutional/religious",
        "existing_use_description": " Commercial, Educational/institutional/religious"
      },
      {
        "existing_use_code": " Hotel/motel",
        "existing_use_description": " Hotel/motel"
      },
      {
        "existing_use_code": " Industrial",
        "existing_use_description": " Industrial"
      },
      {
        "existing_use_code": " Mixed use",
        "existing_use_description": " Mixed use"
      },
      {
        "existing_use_code": " Parking",
        "existing_use_description": " Parking"
      },
      {
        "existing_use_code": " Public facilities",
        "existing_use_description": " Public facilities"
      },
      {
        "existing_use_code": " Residential",
        "existing_use_description": " Residential"
      },
      {
        "existing_use_code": " Vacant",
        "existing_use_description": " Vacant"
      },
      {
        "existing_use_code": "Agricultural/open space",
        "existing_use_description": "Agricultural/open space"
      },
      {
        "existing_use_code": "Commercial Office",
        "existing_use_description": "Commercial Office"
      },
      {
        "existing_use_code": "Forest and Rangeland",
        "existing_use_description": "Forest and Rangeland"
      },
      {
        "existing_use_code": "Heavy Industrial and Utility",
        "existing_use_description": "Heavy Industrial and Utility"
      },
      {
        "existing_use_code": "Light Industrial and Warehouse",
        "existing_use_description": "Light Industrial and Warehouse"
      },
      {
        "existing_use_code": "Medical Parks and Hospitals",
        "existing_use_description": "Medical Parks and Hospitals"
      },
      {
        "existing_use_code": "Military Lands",
        "existing_use_description": "Military Lands"
      },
      {
        "existing_use_code": "Mining and Extractive",
        "existing_use_description": "Mining and Extractive"
      },
      {
        "existing_use_code": "Mixed Use Commercial",
        "existing_use_description": "Mixed Use Commercial"
      },
      {
        "existing_use_code": "Mixed Use Residential",
        "existing_use_description": "Mixed Use Residential"
      },
      {
        "existing_use_code": "Mobile Home Park",
        "existing_use_description": "Mobile Home Park"
      },
      {
        "existing_use_code": "Multifamily Residential",
        "existing_use_description": "Multifamily Residential"
      },
      {
        "existing_use_code": "Park Recreational or Preserve",
        "existing_use_description": "Park Recreational or Preserve"
      },
      {
        "existing_use_code": "Public and Institutional",
        "existing_use_description": "Public and Institutional"
      },
      {
        "existing_use_code": "Retail and Other Commercial",
        "existing_use_description": "Retail and Other Commercial"
      },
      {
        "existing_use_code": "Single Family Residential",
        "existing_use_description": "Single Family Residential"
      },
      {
        "existing_use_code": "Transportation",
        "existing_use_description": "Transportation"
      },
      {
        "existing_use_code": "Vacant or Undeveloped",
        "existing_use_description": "Vacant or Undeveloped"
      },
      {
        "existing_use_code": "Wetlands or Water",
        "existing_use_description": "Wetlands or Water"
      }
     ];

         // Get lookup values for infrastructure access 
    this.$scope.infrastructureAccessLU = this.lookup.getInfrastructureAccess();


    this.$scope.rowCollection = [];
    this.$scope.rowListCollection = [];

    this.$scope.filterLength = 0;

    //Function manages parcel IDs based on check box selection in data table
    $scope.updateBulkIds = function(parcel) {
      // console.log(parcel.isChecked);
      var exists = $scope.bulkIds.indexOf(parcel.parcel_id);
      if(exists > -1) {
        // console.log('exists');
        $scope.bulkIds.splice(exists, 1);
        parcel.isSelected = false;
      } else {
        // console.log('doesnt exist');
        $scope.bulkIds.push(parcel.parcel_id);
        parcel.isSelected = true;
      }

      // console.log($scope.bulkIds);
      $scope.numOfBulkParcels = $scope.bulkIds.length;

      $('#myListTabPanel').addClass('active');
      $('#myListTabNav').addClass('active');
      $('#filtersTabPanel').removeClass('active');
      $('#filtersTabNav').removeClass('active');
    };

    //Select all function selects all check boxes in current table view
    $scope.selectAll = function() {
      $('#myListTabPanel').addClass('active');
      $('#myListTabNav').addClass('active');
      $('#filtersTabPanel').removeClass('active');
      $('#filtersTabNav').removeClass('active');

      $scope.bulkIds = [];
      // console.log($scope);
      $scope.displayedCollection.forEach(element => {
        var parcel = element;
        $scope.bulkIds.push(parcel.parcel_id);
        parcel.isChecked = true;
        parcel.isSelected = true;
      });

      $scope.numOfBulkParcels = $scope.bulkIds.length;
    };

    //Function de-selects all check boxes in current view
    $scope.unselectAllParcels = function () {
      // console.log('unselecting...');
      $scope.rowCollection.forEach(element => {
        var parcel = element;
        $scope.bulkIds.forEach(element2 => {
          var parcel_id = element2;
          if(parcel_id === parcel.parcel_id) {
            console.log(parcel.parcel_id);
            parcel.isSelected = false;
            parcel.isChecked = false;
            $scope.numOfBulkParcels = 0;
            $scope.bulkIds.splice($scope.bulkIds.indexOf(parcel_id), 1);
          }
        });

        //    $scope.bulkIds = [];
      });
    };
  }

  $onInit() {
    // Show data disclaimer 
    var modalCheck = this.lookup.getModalCheck('data');
    console.log(modalCheck);
    if(!modalCheck){
      $('#dataDisclaimerModal').modal();
      this.lookup.setModalCheck('data', true);
    }
    this.loadJurisdictions('Alameda');

    this.loadAllCodes();
    this.updateFilters();

    //Load County List
    this.loadCountyList();

    //Load theme functions
    this.theme.initTheme();

    // Get category layers and colors [Lookup Service]
    this.$scope.hessCategoryLayers = this.lookup.getHessCategoryLayers();

    this.$scope.regional_zoning_lu = [{"zn_regional_code":"1.0","zn_regional_description":"Agriculture"}
    ,{"zn_regional_code":"6.0","zn_regional_description":"Commercial"}
    ,{"zn_regional_code":"11.0","zn_regional_description":"Conservation and Ecology Areas"}
    ,{"zn_regional_code":"7.0","zn_regional_description":"Industrial"}
    ,{"zn_regional_code":"5.0","zn_regional_description":"Mixed Use Commercial"}
    ,{"zn_regional_code":"4.0","zn_regional_description":"Mixed Use Residential"}
    ,{"zn_regional_code":"3.0","zn_regional_description":"Multi-Family Residential"}
    ,{"zn_regional_code":"9.0","zn_regional_description":"Parks and Open Space"}
    ,{"zn_regional_code":"10.0","zn_regional_description":"Public and Institutional"}
    ,{"zn_regional_code":"2.0","zn_regional_description":"Single Family Residential"}
    ,{"zn_regional_code":"12.0","zn_regional_description":"Specific or Special Plan Areas"}
    ,{"zn_regional_code":"8.0","zn_regional_description":"Transportation"}
    ,{"zn_regional_code":"999.0","zn_regional_description":"Unclassified"}];
    

    this.$scope.existing_use_lu = [{"existing_use_description":"Agricultural/open space"}
    ,{"existing_use_description":"Agriculture"}
    ,{"existing_use_description":"Commercial"}
    ,{"existing_use_description":"Commercial Office"}
    ,{"existing_use_description":"Educational/institutional/religious"}
    ,{"existing_use_description":"Forest and Rangeland"}
    ,{"existing_use_description":"Heavy Industrial and Utility"}
    ,{"existing_use_description":"Hotel/motel"}
    ,{"existing_use_description":"Industrial"}
    ,{"existing_use_description":"Light Industrial and Warehouse"}
    ,{"existing_use_description":"Medical Parks and Hospitals"}
    ,{"existing_use_description":"Military Lands"}
    ,{"existing_use_description":"Mining and Extractive"}
    ,{"existing_use_description":"Mixed Use"}
    ,{"existing_use_description":"Mixed Use Commercial"}
    ,{"existing_use_description":"Mixed Use Residential"}
    ,{"existing_use_description":"Mobile Home Park"}
    ,{"existing_use_description":"Multifamily Residential"}
    ,{"existing_use_description":"Parking"}
    ,{"existing_use_description":"Park Recreational or Preserve"}
    ,{"existing_use_description":"Public and Institutional"}
    ,{"existing_use_description":"Public facilities"}
    ,{"existing_use_description":"Residential"}
    ,{"existing_use_description":"Retail and Other Commercial"}
    ,{"existing_use_description":"Single Family Residential"}
    ,{"existing_use_description":"Transportation"}
    ,{"existing_use_description":"Vacant"}
    ,{"existing_use_description":"Vacant or Undeveloped"}
    ,{"existing_use_description":"Wetlands or Water"}]
    

    this.$scope.operators.parcel_size = '>=';
    this.$scope.operators.density = '>=';
    this.$scope.operators.impr_to_land_val = '<=';
  }

  loadHessParcels(type) {
    if(type) {
      this.$scope.type = type;
    }

    if(this.$scope.type === 'allSites') {
      this.$scope.numOfBulkParcels = 0;

      if(this.$scope.allSites.length > 0) {
        this.$scope.rowCollection = this.$scope.allSites;
      } else {
        this.$scope.rowCollection = null;
        this.$http.get(`/api/data/public/hess/parcel/${this.$scope.type}/${this.$scope.jurisdiction}`)
          .then(response => {
            console.log(response.data);
            this.$scope.allSites = response.data;
            this.$scope.rowCollection = response.data;

            if(this.$location.search().category) {
              this.$scope.params = this.$location.search();
              this.$scope.siteStatusFilter = this.$scope.params.category;
              this.$scope.siteStatusFilterDisabled = true;
              //Use alasql to query out records matching the url parameters
              var query = "Select * FROM ? WHERE hess_color = '" + this.$scope.params.category + "'";
              this.$scope.rowCollection = alasql(query, [this.$scope.rowCollection]);

              // console.log(this.$scope.params);
              this.$scope.filterLength = 1;
              this.$location.search({});
            }
          })
          .catch(err => {
            console.log(err);
          });
      }
    } else if(this.$scope.type === 'mySites') {
      var mySitesQuery;
      console.log(this.$scope.allSites);
      if(this.$scope.allSites.length > 0) {
        mySitesQuery = "Select * FROM ? WHERE in_cycle6 = true";
        console.log('my SITES: ', alasql(mySitesQuery, [this.$scope.rowCollection]))
        this.$scope.rowCollection = alasql(mySitesQuery, [this.$scope.rowCollection]);
      } else {
        this.$scope.rowCollection = null;
        this.$http.get('/api/data/hess/parcel/' + this.$scope.type)
          .then(response => {
            console.log("main call my sites: ", response.data);
            this.$scope.rowCollection = response.data;

            if(this.$location.search().category) {
              this.$scope.params = this.$location.search();
              this.$scope.siteStatusFilter = this.$scope.params.category;
              this.$scope.siteStatusFilterDisabled = true;
              //Use alasql to query out records matching the url parameters
              mySitesQuery = "Select * FROM ? WHERE hess_color = '" + this.$scope.params.category + "'";
              this.$scope.rowCollection = alasql(mySitesQuery, [this.$scope.rowCollection]);

              // console.log(this.$scope.params);
              this.$scope.filterLength = 1;
              this.$location.search({});

              // 
            }
          })
          .catch(err => {
            console.log(err);
          });
      }
    }

   
  }

  loadAllCodes() {
    console.log('loading codes');
    this.$scope.zn_codes = [];
    this.$scope.gp_codes = [];
    this.$scope.use_codes = [];
    //Get list of zoning codes. If list doesn't exist in lookup service, request from server
    // if (this.lookup.getZoningCodes().length > 0) {
    //   this.$scope.zn_codes = this.lookup.getZoningCodes();
    // } else {
    this.$http
      .get('/assets/js/data/zn_codes_by_jurisdiction.json')
      .then((response) => {
        console.log("zoning codes: ", response.data);
        this.$scope.zn_codes = _.filter(response.data,function(o){
          return o.jurisdiction === 'Alameda' && o.zn_code
        });
        //Set zoning codes in lookup service
        this.lookup.setZoningCodes(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
    // }

    //Get list of GP codes. If list doesn't exist in lookup service, request from server
    // if (this.lookup.getGPCodes().length > 0) {
    //   this.$scope.gp_codes = this.lookup.getGPCodes();
    // } else {
    this.$http
      .get('/assets/js/data/gp_codes_by_jurisdiction.json')
      .then((response) => {
        this.$scope.gp_codes =  _.filter(response.data,function(o){
          return o.jurisdiction === 'Alameda' && o.gp_code
        });
        console.log("gp_codes: ", this.$scope.gp_codes);
        //Set GP codes in lookup service
        this.lookup.setGPCodes(response.data);
      })
      .catch((err) => {
        console.log(err);
      });

  }

  updateCodes(){
    var jurisdiction = this.$scope.filter.jurisdiction;
    console.log(jurisdiction);
    
    this.$scope.zn_codes =  _.filter(this.lookup.getZoningCodes(),function(o){
      return o.jurisdiction === jurisdiction && o.zn_code
    });
    console.log(this.$scope.zn_codes, " zonning codes");
    
    this.$scope.gp_codes =  _.filter(this.lookup.getGPCodes(),function(o){
      return o.jurisdiction === jurisdiction && o.gp_code
    });
  
}


  loadCountyList() {
    console.log("running...");
    this.$http
      .get("https://data.bayareametro.gov/resource/v6h3-e68p.json?$select=basis_county&$group=basis_county&$order=basis_county")
      .then((response) => {
        console.log(response.data);
        this.$scope.countyList = response.data;
      })
      .catch((err) => {
        console.log(err);
      });
  }

  loadJurisdictions(county) {
    if (county === "Region") {
      this.$scope.jurisdictionList = [];
      console.log(this.$scope.jurisdictionList);
      this.$scope.selectedJurisdiction = "";
      this.getAdoptedSiteList("Region");
    } else {
      this.$http
        .get(
          `https://data.bayareametro.gov/resource/v6h3-e68p.json?basis_county='${county}'`
        )
        .then((response) => {
          this.$scope.jurisdictionList = response.data;
          console.log(this.$scope.jurisdictionList);
          this.$scope.selectedJurisdiction = "";
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }


  updateTableView(type) {
    // console.log(type);
    if(type === 'allList') {
      this.loadHessParcels();
      this.clearFilters();
    } else if(type === 'myList') {
      this.loadSiteList();
    }
  }

  //Update zoning information when zoning code is selected
  updateZnCodeInfo() {
    this.$scope.zn_codes.forEach(element => {
      if(element.zn_recid === this.$scope.hessParcel.zn_recid) {
        console.log(element);
        this.$scope.hessParcel.zn_code = element.zn_code;
        this.$scope.hessParcel.zn_description = element.zn_description;
        this.$scope.hessParcel.zn_regional_code = element.zn_regional_code;
        this.$scope.hessParcel.zn_regional_description = element.zn_regional_description;
        this.$scope.hessParcel.zn_max_dua = element.zn_max_dua;
        this.$scope.hessParcel.zn_min_dua = element.zn_min_dua;
        this.$scope.hessParcel.zn_max_height = element.zn_max_height;

        this.$scope.hessParcel.zn_units_per_lot = element.zn_units_per_lot;
        this.$scope.hessParcel.zn_max_far = element.zn_max_far;
        this.$scope.hessParcel.zn_min_lot_sqft = element.zn_min_lot_sqft;
        this.$scope.hessParcel.zn_lot_coverage_pct = element.zn_lot_coverage_pct;

        //Calculate max capacity
        if(parseFloat(element.zn_max_dua) && parseFloat(this.$scope.hessParcel.acres)) {
          this.$scope.hessParcel.max_capacity = (parseFloat(element.zn_max_dua) * parseFloat(this.$scope.hessParcel.acres)).toFixed(2);
        } else {
          this.$scope.hessParcel.max_capacity = null;
        }
      }
    });



    // console.log(this.$scope.hessParcel.parcel_id);
  }

  //Update GP information when gp code is selected
  updateGPCodeInfo() {
    this.$scope.gp_codes.forEach(element => {
      // console.log(element);
      // console.log(this.$scope.hessParcel.gp_recid);
      if(element.gp_recid === this.$scope.hessParcel.gp_recid) {
        this.$scope.hessParcel.gp_description = element.gp_description;
        this.$scope.hessParcel.gp_code = element.gp_code;
      }
    });
  }

  addSitesToList() {
    // console.log(this.$scope.bulkIds);
    this.$scope.addToSitesSpinner = true;


    this.$http.post('/api/data/hess/parcel/list/add', this.$scope.bulkIds)
      .then(response => {
        // console.log(response.data);

        this.$scope.bulkIds.forEach(element => {
          // console.log("the element: ", element)

          let updateElement = this.$scope.rowCollection.find(o => o.parcel_id === element);
          // console.log("the update element: ", updateElement)
          updateElement.in_cycle6 = true;
          this.$scope.rowListCollection.push(updateElement);
        });


        this.$scope.unselectAllParcels();
        this.$scope.bulkIds = [];
        this.$scope.addToSitesSpinner = false;

        $("#myListTabPanel").addClass("active");
        $("#myListTabNav").addClass("active");
        $("#filtersTabPanel").removeClass("active");
        $("#filtersTabNav").removeClass("active");
      })
      .catch(err => {
        console.log(err);
        this.$scope.addToSitesSpinner = false;
      });
  }

  addGreenSitesToList() {
    this.$scope.addGreenSitesSpinner = true;
    var upsertData = _.map(_.filter(this.$scope.allSites, {
      'hess_category_color': 'Green'
    }), 'parcel_id');
    // console.log(upsertData);

    this.$http.post('/api/data/hess/parcel/list/add', upsertData)
      .then(response => {
        // console.log(response.data);


        upsertData.forEach(element => {
          // console.log("the element: ", element)
          // console.log(this.$scope);
          var updateElement = _.filter(this.$scope.allSites, {
            'parcel_id': element
          });
          // console.log("the update element: ", updateElement)
          updateElement[0].in_list = true;
        });

        this.$scope.unselectAllParcels();
        this.$scope.bulkIds = [];
        this.$scope.addGreenSitesSpinner = false;
        this.updateTableView('list');
      })
      .catch(err => {
        console.log(err);
        this.$scope.addGreenSitesSpinner = false;
      });
  }

  removeSitesFromList(id) {
    // console.log(this.$scope.bulkIds);
    this.$scope.removeSitesSpinner = false;
    this.$http.post('/api/data/hess/parcel/list/remove', this.$scope.bulkIds)
      .then(response => {
        // console.log(response.data);


        this.$scope.bulkIds.forEach(element => {
          let updateElement = this.$scope.rowCollection.find(o => o.parcel_id === element);
          // console.log(updateElement);
          updateElement.in_list = false;
          this.$scope.rowCollection = this.$scope.rowCollection.filter(function (el) {
            return el.parcel_id != element;
          });
          this.$scope.allSites = this.$scope.allSites.filter(function (el) {
            return el.parcel_id != element;
          });
          this.clearFilters();
          // this.$scope.allSites = [];
        });

        this.$scope.unselectAllParcels();
        this.$scope.bulkIds = [];
        this.$scope.numOfBulkParcels = 0;
        this.$scope.removeSitesSpinner = false;
      })
      .catch(err => {
        console.log(err);
        this.$scope.removeSitesSpinner = false;
      });
  }

  /**
   * @desc Opens appropriate update modal window based on parameters
   * @param {object} data - data loaded from value selected in the table
   * @param (string) crudType - type of update operation to perform (values: create, edit or delete)
   */
  openSiteEditModal(parcel_id) {
    this.$scope.parcel_id = parcel_id;
    //Open CRUD Modal
    if (parcel_id) {
      $("#siteSelectionModal").modal();
      this.$http.get(`https://data.bayareametro.gov/resource/nsv6-h4ws.json?$where=parcel_id='${parcel_id}'`,)
      .then(response => {
        console.log(response.data);
        this.$scope.hessParcel = response.data[0];
        //Create percentages and parse integers
        for (const key in this.$scope.hessParcel) {
          this.$scope.affhPercent.forEach(fieldName => {
            if (key === fieldName){
              console.log(key, ' ', fieldName);
              this.$scope.hessParcel[key] = parseInt(100 * this.$scope.hessParcel[key]);
              console.log(this.$scope.hessParcel[key]);
            }
          });
        
        }
        console.log(this.$scope.hessParcel);
      })
      .catch(err => {
        console.log(err);
      })


    }
  }

  downloadSites(){
    alasql('SELECT * INTO XLSX("siteList.xlsx",{headers:true}) FROM ?',[this.$scope.rowCollection]);
  }
  // Start update parcel function
  updateSiteData() {
    var data = this.$scope.hessParcel;


    //Add use code description based on use code
    if(data.existing_use_code && data.existing_use_code !== '') {
      var useCodeQuery = "Select * FROM ? WHERE existing_use_code = '" + data.existing_use_code + "'";
      var useCodeResult = alasql(useCodeQuery, [this.$scope.use_codes]);


      data.existing_use_description = useCodeResult.existing_use_description;
    } else {
      data.existing_use_code = null;
      data.existing_use_description = null;
    }
    // console.log("use codes: ", data.existing_use_code);
    // console.log(data.existing_use_description);

    // console.log(data);

    //test hess category calculation
    this.$http
      .post("/api/data/hess/update", data)
      .then((response) => {
        let updateElement = this.$scope.rowCollection.find(o => o.parcel_id === response.data.parcel_id);
        
        this.$scope.hessCategoryLayers.forEach(element => {
          console.log(element);
          // console.log(element.desc + " - " + response.data.hess_category);
          if(element.desc === response.data.hess_category) {
            // console.log("should be: ", element.name);
            updateElement.hess_color = element.name;
            updateElement.hess_category = response.data.hess_category;
          } else if(response.data.hess_category === 'Parks/ROW Sites') {
            updateElement.hess_color = null;
            updateElement.hess_category = 'Parks/ROW Sites';
          }
        });
        // console.log("new hess color should be: ", updateElement);



        $("#siteSelectionModal").modal("hide");
      })
      .catch((err) => {
        console.log(err);
      });
  }
  openFiltersModal() {
    // console.log('it was clicked');
    $('#newfiltersModal').modal();
  }

  updateFilterLength(){
       //Update zoning and gp codes
       this.updateCodes();

    //County and jurisdiction
    if(this.$scope.filter.pa_county){
     this.loadJurisdictions(this.$scope.filter.pa_county);
   }

       // Remove any false values from filter
       for (const key in this.$scope.filter) {
     
         if (this.$scope.filter.hasOwnProperty(key)) {
           if (this.$scope.filter[key] === false) {
             delete this.$scope.filter[key];
           } 
         } 
       }
   this.$scope.filterLength = Object.keys(this.$scope.filter).length;
 }

  updateFilters() {
    this.$scope.loading = true;
    var operator;
    
    var getDataFilterList = "$where=";
        // Remove any false values from filter
        for (const key in this.$scope.filter) {
      
          if (this.$scope.filter.hasOwnProperty(key)) {
            if (this.$scope.filter[key] === false) {
              delete this.$scope.filter[key];
            } 
          } 
        }

        if(this.$scope.filter.density_operator){
          operator = this.$scope.filter.density_operator;
        }
    
        if(this.$scope.filter.impr_to_land_val_operator){
          operator = this.$scope.filter.impr_to_land_val_operator;
        }
    
        if(this.$scope.filter.parcel_size_operator){
          operator = this.$scope.filter.parcel_size_operator;
        }

        this.$scope.rowCollection = [];
        console.log(this.$scope.filter);
        var filterKey;
    
        // Remove any false values from filter
        for (const key in this.$scope.filter) {
          if (this.$scope.filter.hasOwnProperty(key)) {
            if (this.$scope.filter[key] === false || this.$scope.filter[key] == null || this.$scope.filter[key] === 'null' || this.$scope.filter[key] === 'None') {
              delete this.$scope.filter[key];
            } else if (key === "pa_county" && this.$scope.filter[key] === "Region") {
               delete this.$scope.filter[key];
            } else if(key === 'density_operator' || key === 'impr_to_land_val_operator' || key === 'parcel_size_operator'){
            } else {
              console.log(key, " ", this.$scope.filter[key]);
              filterKey = this.$scope.filter[key];
              
             if(key !== 'density_operator' && key !== 'impr_to_land_val_operator' && key !== 'parcel_size_operator'){
              if (Object.keys(this.$scope.filter).length === 1) {
                if (key === "pa_county" || key === "jurisdiction" || key === 'zn_regional_description' || key === 'infrastructure_access'  
                || key === 'existing_land_use' || key === 'resource_lvl' || key === 'displacement_risk'  || key === 'publicly_owned') {
                  getDataFilterList += `${key}='${filterKey}'`;
                } else if(key === 'zn_max_dua' || key === 'impr_to_land_val' || key === 'acres'){
                  console.log(key, operator, filterKey);
                  getDataFilterList += `${key} ${operator} ${filterKey}`;
                } else {
                  getDataFilterList += `${key}=${filterKey}`;
                }
              } else if (Object.keys(this.$scope.filter).length > 1) {
                if (key === "pa_county" || key === "jurisdiction" || key === 'zn_regional_description'  || key === 'infrastructure_access'  
                  || key === 'existing_land_use' || key === 'resource_lvl' || key === 'displacement_risk'  || key === 'publicly_owned') {
                  getDataFilterList += `${key}='${filterKey}' AND `;
                } else if(key === 'zn_max_dua' || key === 'impr_to_land_val' || key === 'acres'){
                  console.log(key, operator, filterKey);
                  getDataFilterList += `${key} ${operator} ${filterKey} AND `;
                } else {
                  getDataFilterList += `${key}=${filterKey} AND `;
                }
              }
             }
            }
          }
        }

           //Remove last AND
           if (Object.keys(this.$scope.filter).length > 1) {
            getDataFilterList = getDataFilterList.substring(
              0,
              getDataFilterList.length - 4
            );
          }

    getDataFilterList += '&$select=parcel_id,jurisdiction,address,zip_code,apn,consolidated_sites,gp_description,zn_description,zn_min_dua,zn_max_dua,acres,existing_use_description,infrastructure_access,publicly_owned,site_status,used_in_previous_rhna,lwr_inc_cap,mod_inc_cap,abvmod_inc_cap,total_capacity,optional_info_1,optional_info_2,optional_info_3,land_use_source,land_use_last_update'
    getDataFilterList += '&$limit=2000000';
        console.log(getDataFilterList);

    console.log(`https://data.bayareametro.gov/resource/nsv6-h4ws.geojson?${getDataFilterList}`);

    this.$http.get(`https://data.bayareametro.gov/resource/nsv6-h4ws.json?${getDataFilterList}`)
      .then(response => {
        console.log(response.data[0]);
        
        // this.$scope.allSites = response.data;
        this.$scope.rowCollection = response.data;
        this.$scope.search = '';
        this.$scope.siteStatusFilter = '';
        // Update filter length 
        this.$scope.filterLength = Object.keys(this.$scope.filter).length;
        if(this.$scope.filter.impr_to_land_val_operator) {
          this.$scope.filterLength -= 1;
        }

        if(this.$scope.filter.density_operator) {
          this.$scope.filterLength -= 1;
        }

        if(this.$scope.filter.parcel_size_operator) {
          this.$scope.filterLength -= 1;
        }

        $('#newfiltersModal').modal('hide');
        this.$scope.loading = false;
      })
      .catch(err => {
        console.log(err);
      });
  }

  clearFilters() {
    this.$scope.search = '';
    this.$scope.siteStatusFilter = '';
    this.$scope.filter = {
      jurisdiction: 'Alameda',
      in_cycle6: true,
      pa_county: 'Alameda'
    }
    this.updateFilters();
    this.$scope.filterLength = 0;
    
    this.$scope.siteStatusFilterDisabled = false;

    //Reset multi selects
    // $("#znRegionalCodeSelect").val('default');
    // $("#znRegionalCodeSelect").selectpicker("refresh");

    // $("#znCodeSelect").val('default');
    // $("#znCodeSelect").selectpicker("refresh");
  }

  getMyList() {
    this.$http.get('/api/data/hess/parcel/list')
      .then(response => {
        // console.log(response.data);
        this.$scope.myListParcels = response.data;
        this.$scope.rowListCollection = response.data;


        $("#myListTabPanel").addClass("active");
        $("#myListTabNav").addClass("active");
        $("#filtersTabPanel").removeClass("active");
        $("#filtersTabNav").removeClass("active");
      })
      .catch(err => {
        console.log(err);
      });
  }

  getJurisdictions() {
    this.$http.get('/api/data/admin/lookup/jurisdictions')
      .then(response => {
        console.log(this.$scope.user.role);
        console.log(response.data);
        console.log(response.data[0].jurisdiction.split(','));
        if(this.$scope.user.role === 'consultant') {
          var jurisdictions = response.data[0].jurisdiction.split(',');
          var jurisdictionsArray = [];
          jurisdictions.forEach(element => {
            jurisdictionsArray.push({'jurisdiction': element});
          });
          this.$scope.jurisdictions = jurisdictionsArray;
        }
        else if(this.$scope.user.role === 'admin') {
          this.$scope.jurisdictions = response.data;
        }
        console.log(this.$scope.jurisdictions);
      })
      .catch(err => {
        console.log(err);
      });
  }

  updateJurisdiction() {
    console.log(this.$scope.jurisdiction);
    this.$scope.allSites = [];
    this.$scope.rowCollection = [];
    this.loadHessParcels('allSites');
  }

  //  Parcel Notes 
  addParcelNote() {
    var recid = uuid.v1();
    console.log(this.$scope.parcel_note);
    var data = {
      recid: recid,
      note: this.$scope.parcel_note,
      parcel_id: this.$scope.parcel_id
    };

    this.$http
      .post("/api/data/hess/parcel/note/add", data)
      .then((response) => {
        console.log(response.data);
        this.$scope.parcel_note = "";
        this.$scope.parcelNotes.unshift(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  getParcelNotes() {
    this.$http
      .get("/api/data/hess/notes/" + this.$scope.parcel_id )
      .then((response) => {
        this.$scope.parcelNotes = response.data;
        console.log(this.$scope.parcelNotes);
      })
      .catch((err) => {
        console.log(err);
      });
  }
}

export default angular.module('hessApplicationApp.data', [uiRouter])
  .config(routes)
  .component('data', {
    template: require('./data.html'),
    controller: DataComponent,
    controllerAs: 'dataCtrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/data/data.component.js